/**
 * Single key for matching PO supplierName ↔ Suppliers / Poles Tracker SUPPLIER.
 * Fixes under-count when DB has short names (e.g. "Sunbird") and POs use legal
 * names (e.g. "Sunbird Forestry Limited"), or Total Energies spelling variants.
 */
export function normalizeSupplierNameForMatching(name) {
  let s = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[.,'/]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!s) return '';

  const compact = s.replace(/\s+/g, '');

  // Known aliases first
  if (compact === 'totalenergies' || s === 'total energies') {
    return 'totalenergies';
  }

  // Drop common legal / trade suffixes ("Sunbird Forestry Limited" → "sunbird")
  const stripped = s
    .replace(
      /\b(forestry|limited|ltd|llc|inc|incorporated|corp|corporation|company|co|softwoods|enterprises|traders|trading)\b/g,
      ' '
    )
    .replace(/\s+/g, ' ')
    .trim();

  const strippedCompact = stripped.replace(/\s+/g, '');

  if (strippedCompact.startsWith('sunbird') || compact.startsWith('sunbird')) {
    return 'sunbird';
  }

  return strippedCompact || compact || s;
}

/**
 * True when two supplier labels refer to the same vendor
 * (exact canonical key, or one normalized name contains the other).
 */
export function suppliersMatch(a, b) {
  const na = normalizeSupplierNameForMatching(a);
  const nb = normalizeSupplierNameForMatching(b);
  if (!na || !nb) return false;
  if (na === nb) return true;
  // Avoid tiny keys matching everything (e.g. "t")
  if (na.length < 3 || nb.length < 3) return false;
  return na.includes(nb) || nb.includes(na);
}

/** Short label for grouped stats (dashboard, etc.). */
export function displayNameForCanonicalSupplier(canonicalKey, fallbackOriginal) {
  if (canonicalKey === 'totalenergies') return 'TotalEnergies';
  if (canonicalKey === 'sunbird') return 'Sunbird';
  return fallbackOriginal || canonicalKey;
}
